import { QueryKey } from '@tanstack/react-query';
import apiClient from '../../../services/apiClient';
import {
  GoodsFilter,
  GoodsRequest,
  GoodsResponse,
} from '../types/goods-response';
import { TransformFilters } from '../../../utils';

export const WarehouseReqAPI = {
  gets: async (filters: any): Promise<GoodsResponse> => {
    const transformedFilters = TransformFilters(filters);
    const response = await apiClient.get('/api/v3/warehouse/get', {
      params: {
        ...transformedFilters,
        paginate: true,
        page: filters?.page,
      },
    });
    return response.data;
  },
  get: async (id: string): Promise<GoodsRequest> => {
    const response = await apiClient.get(`/api/petition/good/${id}`);
    return response.data;
  },
  put: async (
    id: string,
    data: Record<string, GoodsRequest>
  ): Promise<void> => {
    const response = await apiClient.put(`/api/petition/good/${id}`, data);
    return response.data;
  },
  post: async (req: GoodsRequest): Promise<void> => {
    delete req.id;
    const response = await apiClient.post(
      '/api/petition/good',
      {
        ...req,
        documents: req?.documents?.map((doc) => doc?.file) || [],
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    const response = await apiClient.delete(`/api/petition/good/${id}`);
    return response.data;
  },
  export: async (ids: string[]): Promise<void> => {
    const params = ids.map((id) => `ids[]=${id}`).join('&');
    const response = await apiClient.get(
      `/api/petition/good/export?${params}`,
      {
        responseType: 'blob',
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bienes_exportados.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return response.data;
  },
  annulled: async (
    id: string,
    data: Record<string, GoodsRequest>
  ): Promise<void> => {
    const response = await apiClient.put(
      `/api/petition/good/annulled/${id}`,
      data
    );
    return response.data;
  },
  get_filter_advanced: async (): Promise<GoodsResponse> => {
    const response = await apiClient.post('/api/utils/advance-filters/asset');
    return response.data;
  },
  get_branches: async (id: string, stock: string) => {
    const response = await apiClient.get(`/api/v2/consumer-good/${id}/branches?stock=${stock}`);
    return response.data;
  }
};
